import { Link } from "react-router-dom";
import { ArrowRight, Shield, Users, Briefcase, Megaphone, BookOpen, Handshake, Download, Mail, Phone, Star, CheckCircle } from "lucide-react";
import { Car, Landmark, Zap, Heart, Package, Monitor, UserCheck } from "lucide-react";

const VANTAGGI = [
  { icon: Megaphone, titolo: "Rappresentanza Efficace", desc: "Siamo i portavoce delle aziende, trasmettiamo con fermezza le vostre istanze e proposte alle istituzioni nazionali e locali, con l'obiettivo di ottenere politiche favorevoli alle imprese e alla crescita economica del territorio." },
  { icon: Users, titolo: "Unione e Rappresentanza Settoriale", desc: "Riuniamo le imprese in Associazioni di categoria e territoriali, in reti e filiere di imprese. Questo ci consente di offrire servizi e vantaggi specifici e mirati alle esigenze di ciascun settore." },
  { icon: Shield, titolo: "Partecipazione Attiva", desc: "Siamo presenti ai tavoli negoziali per la stipula dei contratti collettivi di lavoro delle categorie che rappresentiamo. Forniamo assistenza e consulenze mirate in materia di Lavoro e Welfare." },
  { icon: Briefcase, titolo: "Servizi su Misura", desc: "Le aziende associate hanno accesso a una vasta gamma di servizi mirati ai differenti settori di attività, inclusi formazione aggiornata per imprenditori e lavoratori." },
  { icon: Handshake, titolo: "Convenzioni Vantaggiose", desc: "Negoziamo convenzioni vantaggiose per i nostri soci, garantendo opportunità di risparmio e vantaggi che supportano la vostra crescita economica." },
  { icon: BookOpen, titolo: "Informazione e Aggiornamenti", desc: "Offriamo ai Soci un servizio multicanale d'informazione puntuale: sito internet, newsletter, social e Whatsapp Broadcast." },
];

const CONVENZIONI = [
  { icon: Car, nome: "Auto, Mobilità e Trasporti", slug: "auto-mobilita" },
  { icon: Landmark, nome: "Banche e Assicurazioni", slug: "banche-assicurazioni" },
  { icon: Zap, nome: "Energy e Utilities", slug: "energy-utilities" },
  { icon: Heart, nome: "Famiglia, Cultura e Tempo Libero", slug: "famiglia-cultura-tempo-libero" },
  { icon: Package, nome: "Prodotti e Fornitura per l'impresa", slug: "prodotti-fornitura" },
  { icon: Monitor, nome: "Servizi per l'Impresa", slug: "servizi-impresa" },
  { icon: UserCheck, nome: "Welfare e Soluzioni per i dipendenti", slug: "welfare-dipendenti" },
];

const STEPS = [
  { num: "1", titolo: "Scarica il modulo", desc: "Scarica il modulo di adesione in formato PDF.", cta: "Modulo di adesione", url: "https://www.confcommercioroma.it/wp-content/uploads/2024/01/scheda-adesione-2024.pdf" },
  { num: "2", titolo: "Compila il modulo", desc: "Completa il modulo scaricato in tutte le sue parti con i dati della tua impresa." },
  { num: "3", titolo: "Invia il modulo", desc: "Invia a associati@confcommercioroma.it allegando l'attestazione di avvenuto pagamento della quota associativa.", cta: "Coordinate bancarie", url: "https://www.confcommercioroma.it/wp-content/uploads/2026/02/COORDINATE-PAGAMENTO-DELLA-QUOTA-2026.docx.pdf" },
];

export default function AssociatiOraPage() {
  return (
    <main id="main-content" data-testid="associati-ora-page">

      {/* ── HERO ── */}
      <section className="relative h-[380px] md:h-[440px] overflow-hidden">
        <img src="https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=1920&q=60&auto=format" alt="Team imprenditori" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0" style={{ backgroundColor: "rgba(0, 59, 117, 0.90)" }} />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative h-full flex flex-col justify-end pb-12">
          <span className="inline-flex items-center gap-2 text-sm font-semibold text-white bg-white/20 px-4 py-2 rounded-full mb-6 w-fit">
            <Star size={16} aria-hidden="true" /> Campagna Tesseramento 2026
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white font-['Encode_Sans_Semi_Condensed'] tracking-tight leading-[1.1] mb-5">
            Nessuna impresa è troppo piccola<br className="hidden md:block" /> per diventare grande
          </h1>
          <p className="text-xl text-white/85 leading-relaxed mb-8 max-w-3xl">
            Associarsi a Confcommercio Roma significa amplificare la propria voce, accedere a servizi qualificati e inserirsi in una rete che ogni giorno lavora per rafforzare il tessuto economico della città.
          </p>
          <div className="flex flex-wrap gap-4">
            <a href="#come-associarsi" className="inline-flex items-center gap-2 bg-white text-[var(--confcom-blue)] px-8 py-4 rounded-md font-bold text-base hover:opacity-90 transition-opacity shadow-lg">
              Associati ora <ArrowRight size={20} aria-hidden="true" />
            </a>
          </div>
        </div>
      </section>

      {/* ── CAMPAGNA €50 ── */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          {/* Immagine full-width */}
          <img
            src="/local-assets/asbvb3mk_campagna_associativa_50.jpg"
            alt="Campagna tesseramento 2026 - Associati oggi a soli €50"
            className="w-full rounded-2xl shadow-md mb-14"
          />

          {/* Testo + contenuto sotto */}
          <div className="grid lg:grid-cols-2 gap-14 items-start">

            {/* Colonna sinistra: intro + badge */}
            <div>
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed'] mb-3 block">
                Campagna Tesseramento 2026
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] leading-tight mb-6">
                Diventare grandi è una scelta
              </h2>
              <p className="text-[var(--confcom-text-secondary)] leading-loose mb-8">
                In un mercato in continua evoluzione, la crescita non è frutto del caso ma di scelte strategiche mirate. Per l'anno 2026, Confcommercio Roma ha introdotto una <strong className="text-[var(--confcom-text-primary)]">quota speciale di iscrizione di €50,00*</strong>, pensata per abbattere le barriere d'ingresso e sostenere la nascita di nuovi rapporti associativi.
              </p>


            </div>

            {/* Colonna destra: requisiti + CTA */}
            <div>
              <h3 className="text-base font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-3">A chi è riservata</h3>
              <p className="text-sm text-[var(--confcom-text-secondary)] mb-4">L'agevolazione è dedicata alle nuove imprese che si associano tra il 1° gennaio e il 31 dicembre 2026 con i seguenti requisiti:</p>
              <div className="space-y-3 mb-6">
                {[
                  "Non aver avuto rapporti associativi con Confcommercio Roma negli ultimi tre anni",
                  "Avere un organico fino a 5 dipendenti",
                ].map((r) => (
                  <div key={r} className="flex items-start gap-3">
                    <CheckCircle size={17} className="text-[var(--confcom-blue)] shrink-0 mt-0.5" />
                    <span className="text-sm text-[var(--confcom-text-secondary)]">{r}</span>
                  </div>
                ))}
              </div>
              <p className="text-xs text-[var(--confcom-text-muted)] leading-relaxed mb-8">
                *Alcune categorie seguono regimi contributivi specifici e non rientrano nella quota speciale di €50,00: Fedagro, Fiva Roma, Fima Roma, Abiconf Roma, Sib, Asfo Sanità Lazio e FIMAA Roma. Per verificare la quota della tua categoria contatta i nostri uffici.
              </p>
              <div className="flex flex-wrap gap-4">
                <a href="#come-associarsi" className="inline-flex items-center gap-2 bg-[var(--confcom-blue)] text-white px-7 py-3 rounded-md font-semibold hover:opacity-90 transition-opacity text-sm">
                  Scopri come associarti <ArrowRight size={15} />
                </a>
                <a
                  href="https://www.confcommercioroma.it/wp-content/uploads/2026/02/BROCHURE-ISTITUZIONALE-CONFCOMMERCIO-ROMA.pdf"
                  target="_blank" rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 border border-[var(--confcom-blue)] text-[var(--confcom-blue)] px-7 py-3 rounded-md font-semibold hover:opacity-90 transition-opacity text-sm"
                >
                  <Download size={15} /> Brochure istituzionale
                </a>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ── VANTAGGI ── */}
      <section className="py-20 bg-[#EBF5FF]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed']">Perché associarsi</span>
            <h2 className="text-3xl md:text-4xl font-bold text-[var(--confcom-text-primary)] mt-3 font-['Encode_Sans_Semi_Condensed'] tracking-tight">I vantaggi di far parte del sistema</h2>
            <p className="text-[var(--confcom-text-secondary)] mt-4 max-w-2xl mx-auto">Aderire a Confcommercio Roma significa entrare in una rete che sostiene e valorizza imprese del commercio, turismo, servizi e professionisti di Roma e provincia.</p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {VANTAGGI.map((v) => (
              <div key={v.titolo} className="p-6 rounded-xl border border-[var(--confcom-border)] bg-white">
                <div className="w-12 h-12 bg-[var(--confcom-bg-blue-light)] rounded-xl flex items-center justify-center mb-5">
                  <v.icon size={24} className="text-[var(--confcom-blue)]" aria-hidden="true" />
                </div>
                <h3 className="text-base font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-3">{v.titolo}</h3>
                <p className="text-sm text-[var(--confcom-text-secondary)] leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CONVENZIONI ── */}
      <section className="py-20 bg-[#041E42]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed']">Esclusivo per gli associati</span>
            <h2 className="text-3xl md:text-4xl font-bold text-white mt-3 font-['Encode_Sans_Semi_Condensed'] tracking-tight">Convenzioni e Agevolazioni</h2>
            <p className="text-white/70 mt-4 max-w-2xl mx-auto">Sconti e servizi a condizioni agevolate a supporto dell'attività imprenditoriale e delle esigenze personali. Presenta la tua Tessera Associativa ai nostri partner!</p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-12">
            {CONVENZIONI.map((c) => (
              <Link key={c.nome} to={`/convenzioni/${c.slug}`} className="group p-5 rounded-xl bg-white/[0.07] border border-white/10 hover:bg-white/[0.15] transition-all">
                <c.icon size={24} className="text-[#56B7E6] mb-3" aria-hidden="true" />
                <h3 className="text-sm font-semibold text-white font-['Encode_Sans_Semi_Condensed'] group-hover:text-[#56B7E6] transition-colors">{c.nome}</h3>
              </Link>
            ))}
          </div>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/convenzioni" className="inline-flex items-center gap-2 bg-white text-[var(--confcom-blue)] px-6 py-3 rounded-md font-semibold hover:opacity-90 transition-opacity text-sm">
              Scopri tutte le convenzioni <ArrowRight size={16} aria-hidden="true" />
            </Link>
          </div>
        </div>
      </section>

      {/* ── COME ASSOCIARSI ── */}
      <section id="come-associarsi" className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed']">In 3 semplici passi</span>
            <h2 className="text-3xl md:text-4xl font-bold text-[var(--confcom-text-primary)] mt-3 font-['Encode_Sans_Semi_Condensed'] tracking-tight">Come associarsi a Confcommercio</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            {STEPS.map((s) => (
              <div key={s.num} className="flex flex-col bg-[#EBF5FF] rounded-xl border border-[var(--confcom-border)] p-6">
                <div className="w-14 h-14 bg-[var(--confcom-blue)] rounded-2xl flex items-center justify-center text-white text-2xl font-bold font-['Encode_Sans_Semi_Condensed'] shrink-0 mb-5">{s.num}</div>
                <h3 className="text-lg font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-2">{s.titolo}</h3>
                <p className="text-sm text-[var(--confcom-text-secondary)] leading-relaxed mb-4 flex-1">{s.desc}</p>
                {s.cta && (
                  <a href={s.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-[var(--confcom-blue)] text-white px-5 py-2.5 rounded-md text-sm font-medium hover:opacity-90 transition-opacity w-fit">
                    <Download size={14} aria-hidden="true" /> {s.cta}
                  </a>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA FINALE ── */}
      <section className="py-20 bg-[var(--confcom-blue)]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white font-['Encode_Sans_Semi_Condensed'] tracking-tight mb-4">Vuoi essere ricontattato?</h2>
          <p className="text-lg text-white/80 mb-3">Mandaci i tuoi riferimenti specificando il tipo di attività e la zona in cui operi.</p>
          <p className="text-white/70 mb-10">Il referente interno per la tua categoria ti ricontatterà al più presto.</p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <a href="mailto:associati@confcommercioroma.it" className="inline-flex items-center justify-center gap-2 bg-white text-[var(--confcom-blue)] px-8 py-4 rounded-md font-bold hover:opacity-90 transition-opacity shadow-lg">
              <Mail size={18} aria-hidden="true" /> Scrivici subito
            </a>
            <a href="tel:800915915" className="inline-flex items-center justify-center gap-2 border-2 border-white/40 text-white px-8 py-4 rounded-md font-bold hover:opacity-90 transition-opacity">
              <Phone size={18} aria-hidden="true" /> Numero Verde: 800 915 915
            </a>
          </div>
        </div>
      </section>

    </main>
  );
}
